import React from 'react';

/**
 * ValueStack — centered pricing card. Price number is the only element larger
 * than the H1/H2. No checkout here: the CTA scrolls to the request form.
 */
export default function ValueStack({
  eyebrow,
  mainItem,
  yourPrice,
  priceLabel = 'Today',
  priceCaption = '',
  pricingNote = '',
  ctaSlot = null,
}) {
  const money = (n) => `$${Number(n).toLocaleString('en-US')}`;

  return (
    <div className="stack" data-testid="value-stack">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <ul className="lines">
        {mainItem && (
          <li>
            <span><b>{mainItem.name}</b>{mainItem.note && <small>{mainItem.note}</small>}</span>
          </li>
        )}
      </ul>
      <p className="price-label">{priceLabel}</p>
      <p className="price display tab">{money(yourPrice)}</p>
      {priceCaption && <p className="price-caption">{priceCaption}</p>}
      {ctaSlot && <div className="cta-wrap c">{ctaSlot}</div>}
      {pricingNote && <p className="pnote">{pricingNote}</p>}
    </div>
  );
}
